import SPFetch from "@services/SPFetch.class";
import { PromoCodeSuccessResponseType } from "./SignUpFormTypes/signUpFormTypes";
import { logger } from "@utils/logger";
import { useEffect, useState } from "react";
import { Cookie } from "../../../utils/Cookie";

const usePromoCodeSignUpForm = (promoCodeFromBuilder?: string) => {
  const [referralName, setReferralName] = useState("");
  const [isPartner, setIsPartner] = useState(false);

  const promoCode = promoCodeFromBuilder || Cookie.getCookie("PROMOCODE");

  const promoCodeExists = promoCode && promoCode.length > 0;

  const onPromoCodeResolve = (res: PromoCodeSuccessResponseType) => {
    const { data } = res;

    const isPartner =
      data.attributes.signupPageSmallprint &&
      data.attributes.promotionProgram !== "none";

    if (isPartner) {
      const {
        attributes: { signupPageSmallprint },
      } = data;
      setIsPartner(true);
      setReferralName(signupPageSmallprint!);
    }
  };

  useEffect(() => {
    let isMounted = true;

    if (!promoCodeExists) return;

    SPFetch.get(`${process.env.GATSBY_WS_URL}/api/promoCode/${promoCode}`)
      .then((res: PromoCodeSuccessResponseType) => {
        if (isMounted) onPromoCodeResolve(res);
      })
      .catch(err => {
        // handleSetCookie("PROMOCODE", "");
        logger(err.message);
      });
    return () => {
      isMounted = false;
    };
  }, [promoCode, promoCodeExists]);

  return {
    referralName,
    isPartner,
    promoCode: promoCodeExists ? promoCode : "",
  };
};

export default usePromoCodeSignUpForm;
